import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="TERMS OF SERVICE" updated="June 2026" testid="terms-page">
      <p>
        These terms govern your use of Edge Training. By creating an account or using the service you agree
        to them. Items marked <span className="text-amber-400">[PLACEHOLDER]</span> require confirmed
        business details before publication.
      </p>

      <Section heading="1. The service">
        <p>
          Edge Training provides training and coaching-management tools including workout logging, program
          building, assessments, messaging, progress tracking and optional AI features. We may add, change
          or remove features over time.
        </p>
      </Section>

      <Section heading="2. Accounts & eligibility">
        <p>
          You are responsible for the accuracy of your details and for keeping your login secure. You must
          be at least <span className="text-amber-400">[PLACEHOLDER: minimum age]</span> to hold your own
          account. Accounts for young athletes and the required guardian-consent process are described in{" "}
          <span className="text-amber-400">[PLACEHOLDER: guardian-consent policy]</span>. A guardian only
          gains access to an athlete's data after the athlete accepts a link request.
        </p>
      </Section>

      <Section heading="3. Not medical or emergency advice">
        <p>
          Edge Training is a fitness and coaching tool. It does not provide medical advice and does not
          diagnose, treat or manage injuries. AI suggestions and coach programs are for general guidance and
          must be reviewed before use. Pain and readiness reports are shared with your coach for review only;
          they are not monitored in real time and are not an emergency service. If you are injured or unwell,
          seek qualified medical care. You train at your own risk.
        </p>
      </Section>

      <Section heading="4. Subscriptions, billing & pricing">
        <p>
          Paid plans (Edge Training Pro and Coach tiers) are billed through Razorpay for a fixed term
          (monthly or yearly) at the price shown at checkout in Indian Rupees (₹). Access is granted for the
          purchased term and does <b>not</b> auto-renew — it lapses at the end of the term unless you buy
          again. Applicable taxes: <span className="text-amber-400">[PLACEHOLDER: GST / tax details]</span>.
        </p>
      </Section>

      <Section heading="5. Cancellation & downgrade">
        <p>
          Because plans are fixed-term and do not auto-renew, you can stop at any time simply by not
          renewing. If you downgrade or let a plan lapse, your paid features turn off when the current term
          ends and your account reverts to the Free tier. We never delete your athlete records or training
          history when a plan ends or a client limit is exceeded — the data remains and becomes accessible
          again if you upgrade. Refund policy: <span className="text-amber-400">[PLACEHOLDER: refund policy]</span>.
        </p>
      </Section>

      <Section heading="6. Your content">
        <p>
          You keep ownership of the data and media you upload. You grant us the limited rights needed to
          store and display it to operate the service (for example, showing a form-check video to your
          coach). You are responsible for having the rights to what you upload.
        </p>
      </Section>

      <Section heading="7. Acceptable use">
        <p>
          Do not misuse the service, attempt to access data you are not authorised to, upload unlawful
          content, or interfere with other users. We may suspend or terminate accounts that violate these
          terms.
        </p>
      </Section>

      <Section heading="8. Availability & liability">
        <p>
          The service is provided "as is" without warranties. To the extent permitted by law, our liability
          is limited: <span className="text-amber-400">[PLACEHOLDER: liability terms]</span>.
        </p>
      </Section>

      <Section heading="9. Contact">
        <p>Questions about these terms: <span className="text-amber-400">[PLACEHOLDER: contact email]</span>.</p>
      </Section>
    </LegalLayout>
  );
}
